import React from 'react';
import css from './Query.less';
import { SearchOutlined } from '@ant-design/icons';
import Search from '@/src/components/Antd/Search/Search';
import Button from '@/src/components/Antd/Button/Button';
import { FilterType } from './types';
import SelectionFilter from './SelectionFilter';
import FilterItem from './FilterItem';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

export { FilterType };
const Filter = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    pressEnter,
    searchOnchange,
    searchValue,
    onSearch,
    filterList,
    overlayClick,
    searchClassName,
    className,
    placeholder,
    filterData = {},
  } = props;
  const filterListMap = React.useMemo(() => {
    if (filterList && filterList.length) {
      return filterList.map((item, index) => {
        if (item.type === FilterType.selection) {
          return (
            <SelectionFilter
              key={index}
              item={item}
              index={index}
              filterData={filterData[item.dataKey] || []}
              overlayClick={(list) => overlayClick(item, list)}
            />
          );
        }
        if (item.type === FilterType.checkBox) {
          return (
            <FilterItem
              key={index}
              item={item}
              index={index}
              filterData={filterData[item.dataKey] || []}
              overlayClick={(list) => overlayClick(item, list)}
            />
          );
        }
        if (item.type === FilterType.sort) {
          return <div>{getI18n('general.sort')}</div>;
        }
      });
    } else {
      return '';
    }
  }, [filterList, filterData]);
  const filter = (value) => {
    // if (value) {
    //因为新增的时候没有限制输入特殊字符，所以搜索也不需要限制特殊字符
    //   const valueFormat = value.replace(/[^\u4e00-\u9fa5_a-zA-Z0-9]+$/, '');
    //   return valueFormat;
    // } else {
    return value;
    // }
  };
  return (
    <div className={css.queryList}>
      <div className={`${className} ${css.search}`}>
        <Search
          className={searchClassName}
          customFilter={filter}
          placeholder={
            placeholder ? placeholder : getI18n('general.filterGroup.search')
          }
          allowClear
          enterButton={getI18n('general.filterGroup.search')}
          prefix={<SearchOutlined />}
          onPressEnter={(e) => pressEnter(e)}
          onChange={searchOnchange}
          value={searchValue}
          onSearch={onSearch}
        />
      </div>
      {filterList && filterList.length && (
        <div className={css.queryFilter}>
          <Button type='text' className={css.filterText}>
            {getI18n('general.filterGroup.filter')}
          </Button>
          {filterListMap}
        </div>
      )}
    </div>
  );
};
export default Filter;
